import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cnae'
})
export class CNAEPipe implements PipeTransform {
    transform(codigo: number, nome: string, apelido: string): string {
        let result = '';
        // Código
        if (codigo > 0) {
            result += codigo.toString();
        }

        // Apelido ou nome
        const possuiApelido = apelido && apelido.trim() != '';
        const possuiNome = nome && nome.trim() != '';
        if (possuiApelido || possuiNome) {
            if (result != '') {
                result += ' - ';
            }

            if (possuiApelido) { // Apelido
                result += apelido;
            } else { // Nome
                result += nome;
            }
        }

        return result;
    }
}
